import { render } from "./CardCross.vue?vue&type=template&id=7dcaea7c&scoped=true"
import script from "./CardCross.vue?vue&type=script&lang=js"
export * from "./CardCross.vue?vue&type=script&lang=js"

import "./CardCross.vue?vue&type=style&index=0&id=7dcaea7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcaea7c"]])

export default __exports__